/**
 * @description
 * Implements ARIA Menu Radio Group design pattern.
 * @specification
 *  Adds role='group'.
 */
var toolbarMenuRadioGroupBehavior = function toolbarMenuRadioGroupBehavior() {
  return {
    attributes: {
      root: {
        role: 'group'
      }
    }
  };
};

export default toolbarMenuRadioGroupBehavior;